<template>
	<div class="mx-auto">
    <span class="inline-flex items-center rounded-full bg-orange-50 px-2.5 py-0.5 text-xs font-medium text-orange ring-1 ring-inset ring-orange-600/10" v-if="show524 && could_contribute_to_five_twenty_four">
    	<span class="mr-1"><i class="fa-regular fa-plus fa-lg"></i></span>
    	This card will add to your 5/24 count
	</span>
	</div>

</template>
<script>
import { mapState } from "pinia";
import { useNextCardStore } from "@/store/nextcard";

export default {
    name: "CouldContributeToFiveTwentyFour",
    props: {
        could_contribute_to_five_twenty_four: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState(useNextCardStore, ["show524"]),
    },
};
</script>
